<template>
    <div :style="{height: styleheight -60-40 +'px'}">
        <el-row>
            <el-card shadow="hover" class="el-card">
                <div slot="header" class="clearfix">
                    <span>项目详情</span>
                </div>
                <div ><!--:height="height" style="overflow-y: scroll;"-->
                    <el-descriptions class="margin-top" title="" :column="1" :size="size">
                        <el-descriptions-item label="项目pid" :labelStyle="labelStyle">{{item.id}}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" title="" :column="2" :size="size">
                        <!--<template slot="extra">
                            <el-button type="primary" size="small">操作</el-button>
                        </template>-->
                        <el-descriptions-item label="订单编号" :labelStyle="labelStyle">{{item.orderNum}}</el-descriptions-item>
                        <el-descriptions-item label="在线状态" :labelStyle="labelStyle">
                            <span v-if="item.csq<=0" style="color: red;">离线</span>
                            <span v-if="item.csq>0" style="color: green;">在线</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="imei号" :labelStyle="labelStyle">{{item.imei}}</el-descriptions-item>
                        <el-descriptions-item label="通讯状态" :labelStyle="labelStyle">
                            <span v-if="item.alertInfo1!=''" style="color: red;">{{item.alertInfo1}}</span>
                            <span v-if="item.alertInfo1===''" style="color: green;">正常</span>
                        </el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined" label="装机时间">{{form.installTime}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" label="报警状态">
                            <span v-if="item.alertInfo!=''" style="color: red;">{{item.alertInfo}}</span>
                            <span v-if="item.alertInfo===''" style="color: green;">正常</span>
                        </el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined&&form.categoryId!=11&&form.categoryId!=5" label="累计运行时间(分钟)">{{censusForm.runningTime}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.categoryId===1" label="累计点火次数">{{censusForm.fireNum}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined" label="用户姓名">{{form.username}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined&&form.categoryId!=11" label="使用面积(㎡)">{{form.cnarea}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.categoryId===11" label="分水器路数">{{form.routes}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" label="系统类型">{{form.categoryName}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined&&form.categoryId!=3&&form.categoryId!=11" label="系统模式">{{form.systemmodel}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined&&form.categoryId!=3&&form.categoryId!=11" label="品牌机型">{{form.facilities}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" v-if="form.installTime!=undefined" label="详细地址">{{form.location+form.mylocation}}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions v-if="form.categoryId===3" class="margin-top" title="" :column="2" :size="size">
                        <el-descriptions-item :labelStyle="labelStyle" label="中央前置过滤器">{{form.facilities0}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" label="末端净水系统">{{form.facilities1}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" label="中央净水系列">{{form.facilities2}}</el-descriptions-item>
                        <el-descriptions-item :labelStyle="labelStyle" label="中央软水系列">{{form.facilities3}}</el-descriptions-item>
                    </el-descriptions>

                    <el-descriptions class="margin-top" title="" :column="2" :size="size">
                        <!--<el-descriptions-item label="备注">
                            <el-tag size="small">学校</el-tag>
                        </el-descriptions-item>-->
                    </el-descriptions>
                    <el-descriptions class="margin-top" title="" :column="1" :size="size">
                        <el-descriptions-item :labelStyle="labelStyle" label="诊断说明">{{form.alertInfo}}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions class="margin-top" title="" :column="1" :size="size">
                        <el-descriptions-item :labelStyle="labelStyle" label="备注">{{form.remark}}</el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-card>
        </el-row>
        <el-row v-if="this.form.installTime!=undefined" style="margin-top: 15px;">
            <el-card shadow="hover" class="el-card" >
                <div slot="header" class="clearfix">
                    <span>现场图片</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="6" v-for="(o, index) in form.images" :key="index" >
                        <el-card :body-style="{ padding: '0px' }">
                            <el-image class="image"
                                :src="COMMON.httpUrl + '/static' + o + '?token=Bearer '+ token"
                                :preview-src-list="srcList"></el-image>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>
        </el-row>
        <!--isBaoyang-->
        <el-row v-if="(this.form.categoryId===1||this.form.categoryId===2||this.form.categoryId===3)&&this.form.installTime!=undefined"  style="margin-top: 15px;">
            <el-card shadow="hover" class="el-card" >
                <div slot="header" class="clearfix">
                    <span>保养周期</span>
                </div>
                <el-descriptions class="margin-top" title="" :column="4" :size="size">
                    <el-descriptions-item label="保养周期">{{baoyang}} 天
                        <el-button @click="censusClear" type="primary" size="mini" style="margin-left: 10px;padding: 4px 12px;">清除</el-button>
                        <!--<template slot="extra"> v-permission="['SYS-CENSUS-PROJECT-RESET']"
                        </template>-->
                    </el-descriptions-item>
                    <!--<el-descriptions-item><el-button type="primary">清除</el-button></el-descriptions-item>-->
                </el-descriptions>
            </el-card>
        </el-row>
    </div>
</template>

<script>
import { getInstall } from '@/api/install'
import { timeFormat } from '@/utils/common'
import { mapGetters } from 'vuex'
import { maintain, clearCensus, getCensus } from '@/api/census'
import {projectInfo} from '@/api/projects'
export default {
    name: '',
    props: {
        pid: {
            type: Number,
            default: 0
        },
        /*categoryId: {
            type: Number,
            default: null
        },*/
        item: {
            type:Object,
            default: function () {
                return {}
            }
        },
        isBaoyang:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                pid: 0,
                ordernum: '',
                categoryId: null
            },
            size: '',
            baoyang: 0,
            labelStyle:{
                'width': '140px'
            },
            censusForm:{
                runningTime: '',
                fireNum:''
            },
            styleheight:800,
            srcList:[]
        }
    },
    methods: {
        init() {
            getInstall(this.pid).then(response => {
                // console.log('项目详情--获取安装单', response)
                if (response.code != 200) return this.$message.error('项目详情--项目安装单失败！')
                this.form = response.data
                // console.log('form',this.form)
                this.form.installTime = timeFormat(Number(this.form.installTime))
                if(this.form.categoryId===1||this.form.categoryId==='1') {
                    let item=this.form.facilityList[0]
                    this.form.facilities = item.model+' '+item.power+item.powerUnit+' '+item.brand
                    this.census()
                }else if(this.form.categoryId===2||this.form.categoryId==='2') {
                    let item=this.form.facilityList[0]
                    this.form.facilities = item.model+' '+item.airVolume+item.airUnit+' '+item.brand
                    this.census()
                }else if(this.form.categoryId===3||this.form.categoryId==='3') {
                    let item0=this.form.facilityList[0]
                    this.form.facilities0 = item0.model+' '+item0.brand
                    let item1=this.form.facilityList[1]
                    this.form.facilities1 = item1.model+' '+item1.brand
                    let item2=this.form.facilityList[2]
                    this.form.facilities2 = item2.model+' '+item2.brand
                    let item3=this.form.facilityList[3]
                    this.form.facilities3 = item3.model+' '+item3.brand
                    this.census()
                }
                /*this.isBaoyang&&*/
                if(this.form.categoryId===1||this.form.categoryId===2||this.form.categoryId===3){
                    this.getBaoyang()
                }
                for (let i = 0; i < this.form.images.length; i++) {
                    this.srcList.push(this.COMMON.httpUrl + '/static' + this.form.images[i] + '?token=Bearer '+ this.token)
                }
            })
        },
        getBaoyang(){
            console.log('pid',this.pid,this.form)
            maintain(this.form.pid).then(response => {
                console.log('获取保养周期', response)
                if (response.code != 200) return this.$message.error('获取保养周期失败！')
                this.baoyang=response.data
            })
        },
        censusClear(){
            clearCensus(this.form.pid).then(response => {
                console.log('清除保养周期', response)
                if (response.code != 200) return this.$message.error('清除保养周期失败！')
                this.getBaoyang()
            })
        },
        getProjectInfo(){
            // console.log('getProjectInfo-pid',this.pid)
            projectInfo(this.pid).then(response => {
                console.log('getProjectInfo',response)
                if (response.code != 200) return this.$message.error(response.msg)
                this.form=response.data
                // console.log('安装时间',this.form.installTime)
                if(this.form.installTime!=undefined){
                    console.log('有安装时间')
                    this.init()
                }
            })
        },
        census(){
            getCensus(this.form.pid).then(response => {
                // console.log('获取运行时长', response)
                if (response.code != 200) return this.$message.error('获取获取运行时长'+response.msg)
                this.censusForm.runningTime=response.data.runningTime
                this.censusForm.fireNum=response.data.fireNum
                console.log(this.censusForm)
            })
        },
        getHeight() {
            this.styleheight = window.innerHeight
        }
    },
    computed: {
        ...mapGetters([
            'token'
        ])
    },
    watch: {
        pid: {
            handler: function () {
                if(this.pid!=0&&this.pid!=null){
                    this.getProjectInfo()
                }
            }
        }
    },
    created(){
        // console.log(this.item)
        /*if(this.item.installTime!=undefined){
            console.log('有安装时间')
            this.init()
        }else{
            console.log('无安装时间')
        }*/
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        if(this.pid!=0&&this.pid!=null){
            this.getProjectInfo()
        }
    }
}
</script>

<style scoped>
.image {
    width: 100%;
    display: block;
    height: 200px;
}
.el-card >>>.el-card__header {
    padding: 10px 20px !important;
}
#con {
    height: calc(100% - 100);
    /*overflow-y: scroll;*/
}
</style>
